export default "__VITE_ASSET__Dmtx_VFe__"